import React, {useState} from "react";
import { useLangContext } from 'components/shared/Lang';
import {EmptyLayout} from 'components/ant/layouts';
import {Cards} from 'components/ant/ui/Cards';
import { getListingsPageProps } from 'lib/getListingsPageProps';

const Page = (props) => {
    const {listings, vip, page} = props;

    const {t} = useLangContext();
    const [li, setLi] = useState(listings);

    // console.log('listings', listings)

    const getTest = () => {
        fetch(`/api/listings?perPage=30`, {
            method: 'GET',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                setLi({entries: data.data})
                console.log(111111111,data);

            })
            .catch((error) => {
                console.log(error);

            });
    };

    return (
        <EmptyLayout>
            <Cards listings={li} vip={vip} page={page}/>
            {/*<button onClick={() => {getTest()}}>test</button>*/}
        </EmptyLayout>
    );
};

export const getStaticProps = async (ctx) => {
    const {page = 1, location = 'worldwide'} = ctx.params;

    return {
        props: await getListingsPageProps({ locale: ctx.locale, location, page }),
        revalidate: 60,
    };
};

export const getStaticPaths = async () => ({
    paths: [{params: {location: 'worldwide', page: '1'}}],
    fallback: false,
});

export default Page;
